export const FORM_TYPE={
    PREP_TRACKER:'prep_tracker',
    HOME_INFO:'home-info',
    COLLEGE_PRED:'college-predictor'
};